export const backgroundSrc = (header, staticFallback) => {
    if(header)
        return `url(data:image/png;base64,${header})`;
    return `url(${staticFallback})`;
}